import Global from '../global-selectors';
import * as OrdersHelpers from './orders.helpers';
import { getSelectedViewFromPathName } from '../../pages/orders-page/orders-left-nav/orders-left-nav-context';

/**
 * @typedef {object} ViewObject
 * @property {string} id
 * @property {number} count
 * @property {object[]} items - this looks a lot like a ViewObject but has some extra properties on it
 * @property {boolean} expanded
 * @property {any} label - React node
 * @property {boolean} selected
 * @property {string?} routePath
 * @property {boolean?} hideBatchLeftNavigation
 */

/**
 * @param {boolean} notFilteredByStore
 * @param {{ criterionArgumentValue: string, filterById: string }[]} appliedFilters
 * @param {string} statusViewId
 * @returns {string}
 */
const getIdToMatch = (notFilteredByStore, appliedFilters, statusViewId) => {
  const filteredStoreViewId = !notFilteredByStore && appliedFilters.length && appliedFilters[0].criterionArgumentValue;
  const builtViewId = `${statusViewId}-${filteredStoreViewId}`;
  const idToMatch = appliedFilters.length === 1 && appliedFilters[0].filterById === 'store' ? builtViewId : statusViewId;

  return idToMatch;
};

/**
 * @param {object} state - entire redux state object
 * @param {object} history - the history object provided by redux
 * @returns {{ activeFilterViewId: string, appliedFilters: object[], notFilteredByStore: boolean, statusViewId: string, storeGuid: string, leftNavCount: number, shouldGetCounts: boolean }}
 */
export const getReduxValuesForOrderDataRequest = (state, history) => {
  const activeFilterView = Global.selectOrdersFilteringActiveFilterView(state);
  const activeFilterViewId = activeFilterView.filterViewId;
  const sellerDefaultWeightUnit = Global.selectSellerDefaultWeightUnit(state);
  const mappedActiveFilterView = activeFilterView.appliedFilters?.map((filter) => {
    return filter.filterValue === 'OrderWeight' ? { ...filter, criterionMeta: { unit: sellerDefaultWeightUnit } } : filter;
  });
  const appliedFilters = mappedActiveFilterView || [];

  const notFilteredByStore = Global.selectOrdersFilteringNotFilteredByStore(state);

  const stores = Global.selectSellerActiveStores(state);
  // default to awaiting shipment if no view can be found
  const statusView = getSelectedViewFromPathName(history?.location?.pathname, stores);
  const statusViewId = statusView?.id || '';
  const { storeGuid } = statusView || {};
  const storeSelectedAndLocked = !!storeGuid;

  const countMap = Global.selectOrdersNavStatusCountMap(state);
  const idToMatch = getIdToMatch(notFilteredByStore, appliedFilters, statusViewId);
  const selectedCount = countMap?.[idToMatch];
  const leftNavCount = selectedCount ?? 0;

  const shouldGetCounts = OrdersHelpers.shouldMakeSecondCountQuery(
    notFilteredByStore,
    leftNavCount,
    appliedFilters,
    storeSelectedAndLocked,
    statusViewId,
  );

  return {
    activeFilterViewId,
    appliedFilters,
    notFilteredByStore,
    statusViewId,
    storeGuid,
    leftNavCount,
    shouldGetCounts,
  };
};
